import { render, staticRenderFns } from "./accordinBase.vue?vue&type=template&id=6f009603&scoped=true&"
import script from "./accordinBase.vue?vue&type=script&lang=js&"
export * from "./accordinBase.vue?vue&type=script&lang=js&"
import style0 from "./accordinBase.vue?vue&type=style&index=0&id=6f009603&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f009603",
  null
  
)

export default component.exports